module.exports = __webpack_public_path__ + "assets/img/Ic-24h.76261492.svg";